export default __webpack_public_path__ + "static/media/tataconsumerproducts.b7041e29.png";